import { render, staticRenderFns } from "./Bulletpoint.vue?vue&type=template&id=04aa0b65&scoped=true&"
import script from "./Bulletpoint.vue?vue&type=script&lang=ts&"
export * from "./Bulletpoint.vue?vue&type=script&lang=ts&"
import style0 from "./Bulletpoint.vue?vue&type=style&index=0&id=04aa0b65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aa0b65",
  null
  
)

export default component.exports